
    import axios from "axios";
    import { crud_empresa, tabela_create, crud_sql, get_dados_usuario, versao_empresa } from './DSi_sql'
    import { return_key } from './DSi_rotinas'
    import { apagar_pasta, diaParOuImpar } from './DSi_basico'

    var url =  sessionStorage['url']

    export async function  crud_sql_canal (sql) {

        const res = await axios.post(url+'clientes/canal.php', {
            acao:   6,
            meuSQL: sql
        })
      
        // console.log(res.data);
        return res.data
    };

    export async function  crud_abrir_tabela_canal (sql) {

        const res = await axios.post(url+'clientes/canal.php', {
            acao:   5,
            meuSQL: sql
        })
      
        // console.log(res.data);
        return res.data
    };


    // passo o ide para selecionar o cliente
    export async function  crud_abrir_tabela_ponte (ide, sql) {

        const res = await axios.post(url+'clientes/ponte.php', {
            acao:   5,
            ide :  ide,
            meuSQL: sql
        })
      
        // console.log('res.data:', res.data);
        return res.data
    };


    // passo o ide para selecionar o cliente
    export async function  crud_sql_ponte (ide, sql) {

        const res = await axios.post(url+'clientes/ponte.php', {
            acao:   6,
            ide :  ide,
            meuSQL: sql
        })
      
        // console.log(res.data);
        return res.data
    };





    export async function crud_busca_user(db, cpf, senha){


        // busca tambem dados do tipo de cliente 

        if ((!senha)||((senha==' ')||(senha == '   '))){
             senha = 'naodigitousenha!!!!!' 
        }
    

        // altera senha quando loga com a senha de recuperacao
        
        let sql = `UPDATE usuarios set SENHA_RECUPERACAO = null where SENHA_RECUPERACAO = ' ';`
        // console.log(sql);
        await crud_sql_canal(sql) 


        sql = `
            SELECT 
              usuarios.CODIGO_CLIENTE as EMPRESA_CODIGO,
              clientes.NOME as EMPRESA_NOME,
              clientes.SITUACAO,
              clientes.BLOQUEAR,
              clientes.TIPO_CLIENTE,

              usuarios.CODIGO,
              usuarios.NOME as USUARIO,
              usuarios.ATIVO,
              usuarios.EMAIL,
              usuarios.LINK,
              usuarios.SUPER,
              usuarios.CADASTRO_U,
              usuarios.FINANCEIRO_R,
              usuarios.FINANCEIRO_U,
              usuarios.TABELAS_R,
              usuarios.TABELAS_U,
              
              usuarios.PARC_GERAR,
              usuarios.PARC_ALTERA,
              usuarios.PARC_ESTORNA,
              usuarios.PARC_EXCLUI,
              usuarios.DRE,

              usuarios.FIN_TIPO,
              usuarios.AGENDA_U,

              usuarios.SENHA_RECUPERACAO
              
            FROM
              usuarios
              INNER JOIN clientes ON (usuarios.CODIGO_CLIENTE=clientes.CODIGO) 
            WHERE
                (clientes.SITUACAO IN ('ATIVO','TESTE','ENCERRANDO'))and (usuarios.ATIVO = 'S') and
                (usuarios.CPF = '${cpf}') and 
                ((usuarios.SENHA = '${senha}') or (usuarios.SENHA_RECUPERACAO = '${senha}'));
            `


        //   console.log(sql);
        //   return 'exit'
          const res = await axios.post(url+'clientes/canal.php', {
            acao:       5,
            meuSQL:     sql,
          })

        //   console.log('crud_busca_user:', res);
          return res
  

    };




    function define_data_hora(){
        

        let retorno = {}
        //data longa 20 de abrthatil de 2022
        let b = new Date().toLocaleDateString('pt-Br',{ datestyle: 'short',hour12: false, timeZone: 'America/Sao_Paulo' ,  weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'}); 

        retorno.hoje_week = b;
        

        // console.log('update_values');
        let a = new Date().toLocaleDateString('pt-Br',{ datestyle: 'short', hour12: false, timeZone: 'America/Sao_Paulo' });  
        // console.log('hoje = '+ a);

        retorno.hoje = a

        // a = new Date().toLocaleTimeString('pt-Br',{ timeStyle: 'short', hour12: false, timeZone: 'America/Sao_Paulo' });
        a = new Date().toLocaleTimeString('pt-Br',{ hour12: false, timeZone: 'America/Sao_Paulo' });
        // console.log('hora = '+ a);
        retorno.hora = a;

        a = retorno.hoje + '_'+ retorno.hora;
        // console.log('data_hora = '+ a);
        retorno.data_hora = a;


        a = retorno.hoje.slice(6, 10) +'-'+ retorno.hoje.slice(3, 5) +'-'+ retorno.hoje.slice(0, 2) ; //formato us yyyy-mm-dd
        // console.log('today = '+ a);
        retorno.today = a;

        a = retorno.data_hora+' ' /* +this.user */;
        // console.log('alterou = '+ a);
        retorno.quem_alterou = a;


        // console.log(retorno);

        return retorno
    };




    export  function randomString(length){
        const characters ='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  
        let result = ' ';
        const charactersLength = characters.length;
        for ( let i = 0; i < length; i++ ) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
    
        return result;
      };


      export async function enviar_email_recuperacao(para){


        // TRATA A STRING REMOVE CAMPOS E CARACTERES
        para = para.trim()
        para = para.replaceAll("'",'´');//sql injection
          
        let sql =  `select * from usuarios where email = '${para}'`

        let retorno = {}

        // console.log(sql);
        const res = await axios.post(url+'clientes/canal.php', {
            acao  : 5,
            meuSQL: sql,
        })

        console.log('enviar_email_recuperacao:', res.data);


        return retorno =  await executa(this, para, res.data)

        async function executa(that, para, users){

            // ALTERO A SENHA DE RECUPERAÇÃO E MANDO A NOVA SENHA PARA O EMAIL
            let nova_senha  =  randomString(5)
            nova_senha      =  nova_senha.trim()
            nova_senha      = nova_senha.toLocaleLowerCase() //deixo minuscula para facilitar ditiacao no celular..
          
          if (users?.length>0){

                for(let i = 0; i <= users.length-1; i++){

                    let sql = `UPDATE USUARIOS SET USUARIOS.SENHA_RECUPERACAO = '${nova_senha}' WHERE USUARIOS.CODIGO =${users[i]?.CODIGO}`
                    // console.log(sql);
                    await crud_sql_canal(sql) 
                }



                let texto =   `<a href="https://sistemasdsi.com.br"> <img src="https://dsi.app.br/logos/nova_dsi2.png" height="130" alt="Sistemas DSi."> </a> <br>`
                texto     +=  `<br/> Olá <strong style="color:blue">${users[0].NOME}</strong>, conforme solicitação, segue sua senha de recuperação: <br/><br/>`
                texto     +=  `Acesse: <strong style="color:blue">dsi.app.br</strong>`
                texto     +=  `<br/>Senha de Recuperação: <strong style="color:black">${nova_senha}</strong>`
                texto     +=  `<br/><br/><h2>Sistemas DSi</h2>`

                let r = await enviar_email(para,'Recuperação de Senha', texto)
                retorno = { texto : 'Senha de Recuperação enviada para seu e-mail', cor:'green'}

            }
            else{
                retorno = {texto:'E-mail não cadastrado!', cor:'orange lighten-0'}
            }

            return retorno
        }


      };


      export async function enviar_email(para, assunto, texto){
        console.log('enviar_email:');

        var url =  sessionStorage['url']
        let link = url+"email.php"

        const data = {
                  
                  para:      para,
                  assunto:   assunto, 
                  texto:     texto,
        }  

        // console.log(data);
        const header =   { headers: {'Content-Type': 'multipart/form-data'}}

        const res = await axios.post(link, data, header);
        console.log(res.data);
        return res.data

    }; 


    export async function  dsi_user_online(codigo,status){

        let retorno = define_data_hora()
      
        let sql = `UPDATE USUARIOS SET 
                     USUARIOS.ONLINE  = '${status}',
                     ONLINE_HORA      = '${retorno.data_hora}',
                     DATA_HORA_ONLINE = NOW()
                     WHERE USUARIOS.CODIGO =${codigo}`
                     
                     
        // console.log(sql);

        // defino online ou offiline la no DSI... ISSO AQUI TEM QUE SER USADO COM MUITO CUIDADO...
        await crud_sql_canal(sql) 

    };


      export function negritoO(entra, color){
        if(entra){
            if (color){
                color = ` ${color}--text `
            }
            entra = `<b class="font-weight-black ${color} ">${entra}</b>`
        }

        return entra
      };

    export async function  registra_log(tipo,log, codigo_aluno, codigo_conta){

        // console.log('registra_log:');

        let hoje = new Date().toLocaleDateString('pt-Br',{ datestyle: 'short', hour12: false, timeZone: 'America/Sao_Paulo' });  

        let today = hoje.slice(6, 10) +'-'+ hoje.slice(3, 5) +'-'+ hoje.slice(0, 2) ; //formato us yyyy-mm-dd

        let hora = new Date().toLocaleTimeString('pt-Br',{ hour12: false, timeZone: 'America/Sao_Paulo' });
        let hora_curta = hora.slice(0, 5)

        let obj_user = await get_dados_usuario()
        // console.log('registra_log obj_user.CODIGO:', obj_user.CODIGO);

        // let user = sessionStorage['lg:USUARIO']
        let user = obj_user.USUARIO
        user = user.trim()

        let items =   {
            ATIVO            : 'S',
            TIPO             : tipo,
            DATA             : today,
            HORAS            : hora,
            // CODIGO_OPERADOR : sessionStorage['lg:CODIGO'],
            CODIGO_OPERADOR  : obj_user.CODIGO,
            CODIGO_ALUNO     : (codigo_aluno)|| 0,
            OPERADOR         : obj_user.USUARIO,
            DESCRICAO        : log,
            CODIGO_2         : codigo_conta || 0
        }


        let souDSi = false
        let souDSistring = sessionStorage['souDSi']
        if (souDSistring == 'S'){
            souDSi = true
        }
        

        if (!souDSi) {

            if (user !== 'A'){
               await tabela_create(this, 'REGISTRO_LOG', items) //tem que definir o export na declaracao da funcao   
            }
        }
        else{
            await tabela_create(this, 'REGISTRO_LOG', items) //tem que definir o export na declaracao da funcao   
        }

        // alert(souDSi)
    
        // if (url == '/api/'){//localhost
        //     await tabela_create(this, 'REGISTRO_LOG', items) //tem que definir o export na declaracao da funcao   
        // }
        // else{//producao
        //     if (!souDSi) {
        //         if (user !== 'A'){
        //            await tabela_create(this, 'REGISTRO_LOG', items) //tem que definir o export na declaracao da funcao   
        //         }
        //     }
        //     else{
        //         await tabela_create(this, 'REGISTRO_LOG', items) //tem que definir o export na declaracao da funcao   
        //     }
        // }

        


    };

    export async function atualiza_tabelas(){
        console.log('atualiza_tabelas 1');
         
         const res = await axios.get(url+'atu_table.php', {})
        //  let result =  res.data;
         // alert(result)
         console.log('atualiza_tabelas 2:', res.data)
    };

    
    export async function backup_database(){
        console.log('backup_database url:', url);
         
         const res = await axios.post(url+'backup.php')
        //  let result =  res.data;
         // alert(result)
         console.log(res.data)
    };


    export async function updateVersoes(versaoAtual){

        console.log('updateVersoes');

        versaoAtual = sessionStorage['versao']
        // alert(3)
        // alert(versaoAtual)

        let sql = []
        let rr = ''
        let v = versaoAtual
        v = somenteNumeros(v)
        // alert(v)

        let apagar_colunas_antigas = false

        //pega versao la na empresa
        let vantigo = (await versao_empresa())[0].VERSAO_ATUAL || 0;
        console.log(`versao na empresa: ${vantigo}\nversao atual: ${v}`, );
        


    
        

        // MANUTENÇÃO NO PROPRIO BD
        sql.push( `DELETE FROM ALUNOS    WHERE ATIVO = 'X' AND DATA_EXCLUSAO <= DATE_SUB(CURDATE(), INTERVAL 7 DAY)`)//2136 apaga contas depois de 48 horas estando como X
        sql.push( `DELETE FROM CONTA     WHERE ATIVO = 'X' AND DATA_EXCLUSAO <= DATE_SUB(CURDATE(), INTERVAL 7 DAY)`)//2136 apaga contas depois de 48 horas estando como X
        sql.push( `DELETE FROM SERVICOS  WHERE ATIVO = 'X' AND DATA_EXCLUSAO <= DATE_SUB(CURDATE(), INTERVAL 7 DAY)`)//2136 apaga contas depois de 48 horas estando como X
        sql.push( `DELETE FROM AGENDA    WHERE ATIVO = 'X' AND DATA_EXCLUSAO <= DATE_SUB(CURDATE(), INTERVAL 7 DAY)`)//2136 apaga aulas depois de 3 mese estando como X
        sql.push( `DELETE FROM AGENDA    WHERE DATA  <= DATE_SUB(CURDATE(), INTERVAL 12 MONTH)`)//2136 apaga aulas depois de 1 ano
        sql.push( `DELETE FROM recibo_impressos WHERE DATA <= DATE_SUB(CURDATE(), INTERVAL 9 MONTH)`)//2136 apaga contas depois de 6 meses
        sql.push( `DELETE FROM processos_apropriacao WHERE DATA <= DATE_SUB(CURDATE(), INTERVAL 2 MONTH)`)//2136 apaga processos_apropriacao depois de 2 meses

        // sql.push( `DELETE FROM usuarios WHERE DATA_HORA_ONLINE IS NULL OR DATA_HORA_ONLINE < DATE_SUB(CURDATE(), INTERVAL 18 MONTH);`)//apaga usuarios que nao conectam ha algum tempo

        console.log('1.1');
        // sql.push( `UPDATE ALERTA SET ALERTA.VISTO = 'S' WHERE ALERTA.DATA_ALERTA <= '2024-12-01'`)//2136 
        sql.push( `UPDATE alunos SET WHATS_NIVER = NULL WHERE (WHATS_NIVER) <> YEAR(CURDATE())`)
        sql.push( `DELETE FROM alerta WHERE DATA_ALERTA <= DATE_SUB(CURDATE(), INTERVAL 12 MONTH)`)
        sql.push( `update conta set VENDAS_DRE = 'S' where VENDAS_DRE is null or VENDAS_DRE = ''`)//2216

        console.log('1.2');
        // remove do app antigo
        if (apagar_colunas_antigas){

            console.log('removendo colunas do app antigo');

            sql.push( `ALTER TABLE alunos DROP COLUMN CODIGO_DESK`)//2194
            sql.push( `ALTER TABLE alunos DROP COLUMN CODIGOALUNO`)//2194
            sql.push( `ALTER TABLE alunos DROP COLUMN PROTOCOLO`)//2194
            sql.push( `ALTER TABLE alunos DROP COLUMN NOMECOMPLETO`)//2194
            sql.push( `ALTER TABLE alunos DROP COLUMN NOMEALUNO`)//2194
            sql.push( `ALTER TABLE alunos DROP COLUMN CONCLUIUTUDO`)//2194
            sql.push( `ALTER TABLE alunos DROP COLUMN RGALUNO`)//2194
            sql.push( `ALTER TABLE alunos DROP COLUMN CPFALUNO`)//2194
            sql.push( `ALTER TABLE alunos DROP COLUMN FONEALUNO`)//2194
            sql.push( `ALTER TABLE alunos DROP COLUMN CELULARALUNO`)//2194
            sql.push( `ALTER TABLE alunos DROP COLUMN CELULARALUNO_2`)//2194
            sql.push( `ALTER TABLE alunos DROP COLUMN NOMEPAI`)//2194
            sql.push( `ALTER TABLE alunos DROP COLUMN NOMEMAE`)//2194
            sql.push( `ALTER TABLE alunos DROP COLUMN ALUNOWORK`)//2194
            sql.push( `ALTER TABLE alunos DROP COLUMN DATANASCIMENTO`)//2194
            sql.push( `ALTER TABLE alunos DROP COLUMN KEMALTEROU`)//2194
            sql.push( `ALTER TABLE alunos DROP COLUMN DATADOCADASTRO`)//2194
            sql.push( `ALTER TABLE alunos DROP COLUMN DATA_CADASTROU`)//2194
            sql.push( `ALTER TABLE alunos DROP COLUMN TOTALDACARTEIRA`)//2194
            sql.push( `ALTER TABLE alunos DROP COLUMN TIPODEREKISICAO`)//2194
            sql.push( `ALTER TABLE alunos DROP COLUMN ENDNUMERO`)//2194
            sql.push( `ALTER TABLE alunos DROP COLUMN OBS`)//2194
            sql.push( `ALTER TABLE alunos DROP COLUMN RGORGAO`)//2194
            sql.push( `ALTER TABLE alunos DROP COLUMN ESTADOCIVIL`)//2194
            sql.push( `ALTER TABLE alunos DROP COLUMN IDADE`)//2194

            sql.push( `ALTER TABLE conta DROP COLUMN CODIGO_DESK`)//2110//remove a coluna CODIGO_DESK esta dando erro ao receber parcial
            sql.push( `ALTER TABLE conta DROP COLUMN CODIGOALUNO`)//2110//remove a coluna CODIGO_DESK esta dando erro ao receber parcial
            sql.push( `ALTER TABLE conta DROP COLUMN PAGAREM`)//2110//remove a coluna CODIGO_DESK esta dando erro ao receber parcial
            sql.push( `ALTER TABLE conta DROP COLUMN PAGOEM`)//2110//remove a coluna CODIGO_DESK esta dando erro ao receber parcial
            sql.push( `ALTER TABLE conta DROP COLUMN VALORTOTAL`)//2110//remove a coluna CODIGO_DESK esta dando erro ao receber parcial
            sql.push( `ALTER TABLE conta DROP COLUMN FORMA_PG`)//2110//remove a coluna CODIGO_DESK esta dando erro ao receber parcial
            sql.push( `ALTER TABLE conta DROP COLUMN BOLETO`)//2110//remove a coluna CODIGO_DESK esta dando erro ao receber parcial
            sql.push( `ALTER TABLE conta DROP COLUMN VALORPOREXTENSO`)//2110//remove a coluna CODIGO_DESK esta dando erro ao receber parcial
            sql.push( `ALTER TABLE conta DROP COLUMN STATUS`)//2110//remove a coluna CODIGO_DESK esta dando erro ao receber parcial
        }


        console.log('1.3');
    
        // console.log(`ATUALIZANDO VERSÃO ${ve}`);

        // caso queira fazer algo especifico no localhost
        if (url == '/api/'){
            // return false
        }


        console.log('1.3.1');
        // quando no teste, atualiza as datas pra hoje pra mostrar dados pros interessados
        let idee    =  JSON.parse(sessionStorage['obj_user'])  
        if (idee.EMPRESA_CODIGO==1){
            // alert('sou teste')
            sql.push( `update alunos set DATA_NASCIMENTO = DATE_SUB(CURDATE(), INTERVAL 18 YEAR)`)
            sql.push( `
                UPDATE conta
                SET
                    DATA_VENDA = CURDATE(),
                    DATA_VENCIMENTO = CASE
                        WHEN MOD(CODIGO, 2) = 0 THEN CURDATE()
                        ELSE DATE_SUB(CURDATE(), INTERVAL 30 DAY)
                    END,
                    DATA_EFETUADO = CASE
                        WHEN MOD(CODIGO, 10) = 0 THEN CURDATE()
                        ELSE NULL
                    END,
                    PAGO = CASE
                        WHEN MOD(CODIGO, 10) = 0 THEN 'S'
                        ELSE 'N'
                    END;`
            )

            sql.push( `UPDATE agenda
                    SET DATA = STR_TO_DATE(
                        CONCAT(
                            YEAR(CURDATE()), '-',
                            LPAD(MONTH(CURDATE()), 2, '0'), '-',
                            LPAD(DAY(DATA), 2, '0')
                        ),
                        '%Y-%m-%d'
                    );`
            )
        }



        

        console.log('1.4');
        console.log(`ATUALIZANDO VERSÃO ${vantigo}`);

        if (vantigo <= 2223){ 
            // sql.push( `update assinaturas set API_LINK = 'http://2.25.202.91:8051/@token/send-messages' where API_LINK = 'http://dsi.app.br:8051/@token/send-messages'`)
            sql.push( `ALTER TABLE servicos ADD COLUMN JA_TOXICO varchar(10)`)
        }

        if (vantigo <= 2220){ 
            sql.push( `ALTER TABLE alunos ADD COLUMN NOME_PIX varchar(60)`)
            sql.push( `ALTER TABLE sub_agenda ADD COLUMN ID_ONLINE varchar(20)`)
            sql.push( `ALTER TABLE sub_agenda ADD COLUMN DATA_HORA_VISTO varchar(40)`)
            sql.push( `ALTER TABLE alunos ADD COLUMN CNH_CFC varchar(1)`)
        }

        if (vantigo <= 2219){ 
            sql.push( `ALTER TABLE agenda ADD COLUMN LIMITE int(9)`)
            sql.push( `ALTER TABLE alunos ADD COLUMN DADOS_PIX varchar(40)`)
            sql.push( `ALTER TABLE alunos ADD COLUMN OBSERVACAO_2 text`)//usar text no lugar de varchar(9999)
            sql.push( `ALTER TABLE alunos ADD COLUMN OBSERVACAO_3 text`)
            sql.push( `ALTER TABLE alunos ADD COLUMN OBSERVACAO_4 text`)

            sql.push( `ALTER TABLE sub_agenda ADD COLUMN DATA_CADASTRADO varchar(30)`)
            sql.push( `ALTER TABLE sub_agenda ADD COLUMN VISTO varchar(1)`)

            sql.push( `ALTER TABLE agenda ADD COLUMN CODIGO_FORNECEDOR int(9)`)
        }

        if (vantigo <= 2217){ 
            sql.push( `ALTER TABLE empresa ADD COLUMN EMAIL_HOST varchar(90)`)
            sql.push( `ALTER TABLE empresa ADD COLUMN EMAIL_USER varchar(50)`)
            sql.push( `ALTER TABLE empresa ADD COLUMN EMAIL_PASS varchar(50)`)
            sql.push( `ALTER TABLE empresa ADD COLUMN EMAIL_PORT varchar(10)`)
        }

        if (vantigo <= 2216){ 
            sql.push( `ALTER TABLE conta ADD COLUMN VENDAS_DRE varchar(10)`)//2216
            sql.push( `update conta set VENDAS_DRE = 'S' where VENDAS_DRE is null or VENDAS_DRE = ''`)//2216
            sql.push( `ALTER TABLE servicos ADD COLUMN NUM_AULAS_GERAL varchar(20)`)//2216
            // sql.push( `update servicos set NUM_AULAS_GERAL = null`)//2216
            sql.push( `
                    UPDATE servicos
                    SET NUM_AULAS_GERAL = CONCAT(
                    IF(NUM_AULAS IS NOT NULL AND NUM_AULAS <> 0, CONCAT(NUM_AULAS, 'A '), ''),
                    IF(NUM_AULAS_B IS NOT NULL AND NUM_AULAS_B <> 0, CONCAT(NUM_AULAS_B, 'B '), '')
                    )
                    WHERE NUM_AULAS_GERAL IS NULL;
                `)//2216
        }

        if (vantigo <= 2215){ 
            sql.push( `ALTER TABLE whats_respostas ADD ATIVO varchar(10)`)//2215
            sql.push( `update whats_respostas set ativo = 'S' where ativo is null`)//2215
            sql.push( `ALTER TABLE servicos ADD COLUMN NUM_AULAS_B int(9)`)//2214
        }

        if (vantigo <= 2213){ 

            sql.push( `ALTER TABLE empresa ADD COLUMN URL_FILES varchar(200)`)//2213
            sql.push( `ALTER TABLE empresa ADD COLUMN FTP_URL varchar(200)`)//2213
            sql.push( `ALTER TABLE empresa ADD COLUMN FTP_USER varchar(50)`)//2213
            sql.push( `ALTER TABLE empresa ADD COLUMN FTP_PASS varchar(50)`)//2213
            sql.push( `ALTER TABLE empresa ADD COLUMN FTP_PORT varchar(10)`)//2213
            sql.push( `ALTER TABLE empresa ADD COLUMN FTP_ATIVO varchar(10)`)//2213
        }

        if (vantigo <= 2211){  

            sql.push( `ALTER TABLE alunos ADD COLUMN DATA_EXCLUSAO date`)//2210
            sql.push( `ALTER TABLE servicos ADD COLUMN DATA_EXCLUSAO date`)//2210
            sql.push( `ALTER TABLE servicos ADD COLUMN ATIVO varchar(1)`)//2210
            sql.push( `update servicos set ATIVO = 'S' where ATIVO is null`)//2210

            sql.push( `ALTER TABLE agenda ADD COLUMN DATA_EXCLUSAO date`)//2210

            sql.push( `ALTER TABLE recibo_impressos CHANGE COLUMN CODIGO_CONTA_STRING CODIGO_CONTA_STRING VARCHAR(150)`)//2196
            sql.push( `ALTER TABLE tabela_cobranca ADD COLUMN NFE_AUTOMATICO varchar(10)`)//2207
        }

        if (vantigo <= 2208){  

            sql.push( `ALTER TABLE clientes ADD COLUMN NUM_ENDERECO varchar(10)`)//2207
            sql.push( `ALTER TABLE clientes ADD COLUMN COMPLEMENTO varchar(30)`)//2207

            sql.push( `ALTER TABLE conta ADD COLUMN NFE_ID varchar(100)`)//2203
            sql.push( `ALTER TABLE conta ADD COLUMN NFE_GERADO date`)//2203
            sql.push( `ALTER TABLE conta ADD COLUMN NFE_URL varchar(300)`)//2203
            sql.push( `ALTER TABLE conta ADD COLUMN NFE_XML varchar(300)`)//2203
            sql.push( `ALTER TABLE conta ADD COLUMN NFE_ENVIOU varchar(10)`)//2203

            sql.push( `ALTER TABLE conta ADD COLUMN EMITIU_NFE varchar(10)`)//2200
            sql.push( `ALTER TABLE conta ADD COLUMN SEQUENCIA int(9)`)//2200
        }

        if (vantigo <= 2200){  

            sql.push( `UPDATE registro_log SET TIPO = 'LOGIN' WHERE TIPO = 'ENTROU'`)//2200
            sql.push( `UPDATE registro_log SET TIPO = 'LOGIN' WHERE TIPO = 'SAIU'`)//2200
            sql.push( `ALTER TABLE conta ADD COLUMN NOTA_FISCAL varchar(30)`)//2200
        }


        if (vantigo <= 2199){
            
            console.log(`<=2199`);

            if (url == '/api/'){
                // return false
            }
            
            // sql.push( `UPDATE whats_respostas AS r
            // JOIN whats_menus AS m ON m.CODIGO = r.RESPOSTA
            // SET r.TEXTO_AUSENTE = m.ID
            // WHERE r.TIPO = 'MENU'`)//2113

            // sql.push( `UPDATE whats_respostas set RESPOSTA = TEXTO_AUSENTE WHERE whats_respostas.TIPO = 'MENU'`)//2113
            // sql.push( `UPDATE whats_respostas set ID_MENU = (select ID from whats_menus where CODIGO = whats_respostas.COD_MENU)`)//2113

            // sql.push( `update alunos set celular = CELULAR_2 where celular is null or celular=''`)//2195

            sql.push( `ALTER TABLE servicos ADD COLUMN CAR_AUTOMATICO varchar(10)`)//2200

            sql.push( `ALTER TABLE tabela_api_whats CHANGE COLUMN CELULAR CELULAR VARCHAR(30)`)//2196

            sql.push( `ALTER TABLE usuarios ADD COLUMN DATA_HORA_ONLINE varchar(20)`)//2195

            sql.push( `ALTER TABLE servicos ADD COLUMN NUM_AULAS int(9)`)//2193
            sql.push( `ALTER TABLE servicos ADD COLUMN CNH_BRASIL varchar(10)`)//2193
            sql.push( `ALTER TABLE servicos ADD COLUMN PAGOU_TAXA varchar(10)`)//2192
            sql.push( `ALTER TABLE alunos DROP COLUMN PAGOU_TAXA`)//2190
            sql.push( `ALTER TABLE clientes ADD COLUMN double_DESCONTO double(10,2)`)//2192

            sql.push( `ALTER TABLE web_registros DROP COLUMN DADOS_GEO`)//2190
            sql.push( `ALTER TABLE web_registros DROP COLUMN PATH_ASSINATURA`)//2190
            sql.push( `ALTER TABLE web_registros DROP COLUMN DADOS_ASSINATURA`)//2190
            sql.push( `ALTER TABLE web_registros DROP COLUMN ASSINATURA_EMPRESA`)//2190
            
            sql.push( `ALTER TABLE web_registros ADD COLUMN IMG_ASSINATURA_1 blob`)//2189
            sql.push( `ALTER TABLE web_registros ADD COLUMN DADOS_ASSINATURA_1 blob`)//2189
            
            sql.push( `ALTER TABLE web_registros ADD COLUMN IMG_ASSINATURA_2 blob`)//2189
            sql.push( `ALTER TABLE web_registros ADD COLUMN DADOS_ASSINATURA_2 blob`)//2189

            sql.push( `ALTER TABLE web_registros ADD COLUMN KEY_SQL varchar(20)`)//2190 
            
            sql.push( `ALTER TABLE empresa ADD COLUMN ASSINATURA_EMPRESA blob`)//2189

            sql.push( `UPDATE ALUNOS SET TIPO_DOC = 'RG' WHERE TIPO_DOC IS NULL`)//2139

            sql.push( `ALTER TABLE alunos ADD COLUMN TIPO_DOC varchar(20)`)//2185

            sql.push( `ALTER TABLE alunos ADD COLUMN RESTRICAO_CPF varchar(1)`)//2184

            sql.push( `ALTER TABLE conta ADD COLUMN QUEM_EFETUOU_CODIGO int(9)`)//2182

            sql.push( `ALTER TABLE usuarios ADD COLUMN AGENDA_U varchar(1)`)//2180
            sql.push( `UPDATE usuarios set AGENDA_U = CADASTRO_U where AGENDA_U is null`)//2176
            

            sql.push( `ALTER TABLE empresa ADD COLUMN JUROS_DIAS_TOLERANCIA int(11)`)//2176
            sql.push( `UPDATE empresa set JUROS_DIAS_TOLERANCIA = 0 where JUROS_DIAS_TOLERANCIA is null`)//2176

            sql.push( `ALTER TABLE usuarios ADD COLUMN FIN_TIPO varchar(40)`)//2175
            sql.push( `ALTER TABLE usuarios ADD COLUMN FIN_ESTATISTICAS varchar(40)`)//2175
            sql.push( `update usuarios set FIN_TIPO = FINANCEIRO_R where FIN_TIPO is null`)//2175
            sql.push( `update usuarios set FIN_ESTATISTICAS = FINANCEIRO_R where FIN_ESTATISTICAS is null`)//2175
            sql.push( `update usuarios set DRE = FINANCEIRO_R where DRE is null`)//2175

            sql.push( `ALTER TABLE alunos ADD COLUMN TIPO_CADASTRO varchar(20)`)//2169
            sql.push( `ALTER TABLE alunos ADD COLUMN CNPJ varchar(25)`)//2169
            sql.push( `UPDATE ALUNOS SET TIPO_CADASTRO = 'PF' WHERE TIPO_CADASTRO IS NULL`)//2139
            
            sql.push( `ALTER TABLE conta ADD COLUMN DATA_EXCLUSAO date`)//2165
            sql.push( `ALTER TABLE conta ADD COLUMN ATIVO varchar(10)`)//2165
            sql.push( `UPDATE conta SET ATIVO = 'S' WHERE ATIVO IS NULL`)

            sql.push( `ALTER TABLE alunos ADD COLUMN DESCRICAO_SERVICO varchar(160)`)//2162
            sql.push( `ALTER TABLE empresa ADD COLUMN MSG_CARNE varchar(120)`)//2162

            // sql.push( `ALTER TABLE tabela_impressao ADD COLUMN M_ASSINATURAS TINYINT(1) NOT NULL DEFAULT 0`)//2160
            // sql.push( `ALTER TABLE tabela_impressao ADD COLUMN M_TESTEMUNHAS TINYINT(1) NOT NULL DEFAULT 0`)//2160

            // sql.push( `ALTER TABLE alunos ADD COLUMN CNH_VALIDADE date`)//2159

            // sql.push( `ALTER TABLE alerta ADD COLUMN CODIGO_SERVICO int(9)`)//2151

            // sql.push( `ALTER TABLE alunos ADD COLUMN RG_UF varchar(10)`)//2151
            // sql.push( `ALTER TABLE alunos ADD COLUMN CNH_UF varchar(10)`)//2151
            // sql.push( `ALTER TABLE alunos ADD COLUMN ENDERECO_NUM varchar(10)`)//2151

            // sql.push( `ALTER TABLE servicos ADD COLUMN AUTO_INFRACAO varchar(90)`)//2150
            // sql.push( `ALTER TABLE servicos ADD COLUMN TIPO_CONDUTOR varchar(90)`)//2150
            // sql.push( `ALTER TABLE servicos ADD COLUMN N_PROTOCOLO varchar(90)`)//2150
            // sql.push( `ALTER TABLE servicos ADD COLUMN N_PROCESSO_ADM varchar(90)`)//2150
            // sql.push( `ALTER TABLE servicos ADD COLUMN MOTIVO varchar(90)`)//2150
            // sql.push( `ALTER TABLE servicos ADD COLUMN PLACA varchar(20)`)//2150
            // sql.push( `ALTER TABLE servicos ADD COLUMN RENAVAM varchar(150)`)//2150
            // sql.push( `ALTER TABLE servicos ADD COLUMN JUSTIFICATIVA varchar(9999)`)//2150
            // sql.push( `ALTER TABLE servicos MODIFY COLUMN ALERTA_EXPIRA VARCHAR(20)`)//2150

            // sql.push( `ALTER TABLE processos_apropriacao DROP COLUMN CATEGORIA`)//2150

            // sql.push( `ALTER TABLE agenda MODIFY COLUMN DESCRICAO VARCHAR(200)`)//2148

            // sql.push( `ALTER TABLE empresa ADD COLUMN CHAVE_PIX varchar(90)`)//2145
            // sql.push( `ALTER TABLE empresa ADD COLUMN TIPO_CHAVE varchar(90)`)//2145

            // sql.push( `ALTER TABLE usuarios ADD COLUMN DRE varchar(1)`)//2141

            // sql.push( `ALTER TABLE empresa ADD COLUMN MSG_NIVER varchar(999)`)//2139
            // sql.push( `ALTER TABLE empresa ADD COLUMN MSG_PREVISAO varchar(999)`)//2139
            // sql.push( `ALTER TABLE empresa ADD COLUMN MSG_COBRANCA varchar(999)`)//2139
            
            // sql.push( `ALTER TABLE conta ADD COLUMN COBRAR_JUROS varchar(10)`)//2138

            // sql.push( `ALTER TABLE tabela_cobranca ADD COLUMN AVISAR_RECEBIMENTO varchar(20)`)//2135
            // sql.push( `ALTER TABLE tabela_cobranca ADD COLUMN AVISAR_NUMERO varchar(20)`)//2135

            // sql.push( `ALTER TABLE alunos ADD COLUMN AULA_DATA_TURMA date`)//2133
            // sql.push( `ALTER TABLE alunos ADD COLUMN INDICACAO varchar(60)`)//2133

            // sql.push( `ALTER TABLE agenda ADD COLUMN TIPO varchar(20)`)//2133

            // sql.push( `ALTER TABLE web_registros ADD COLUMN VISTO varchar(10)`)//2132
            // sql.push( `ALTER TABLE web_registros ADD COLUMN CAPTION_1 varchar(90)`)//2132
            // sql.push( `ALTER TABLE web_registros ADD COLUMN CAPTION_2 varchar(90)`)//2132


            // sql.push( `ALTER TABLE veiculos ADD COLUMN HORARIOS varchar(999)`)//2131
            // sql.push( `ALTER TABLE veiculos ADD COLUMN DURACAO varchar(10)`)//2131
            // sql.push( `ALTER TABLE veiculos ADD COLUMN LIMITE_DIA integer`)//2131
            // sql.push( `ALTER TABLE veiculos ADD COLUMN LIMITE_SEMANA integer`)//2131
            // sql.push( `ALTER TABLE veiculos ADD COLUMN LIMITE_TOTAL integer`)//2131

            // sql.push( `ALTER TABLE instrutores ADD COLUMN CELULAR varchar(20)`)//2131
            // sql.push( `ALTER TABLE instrutores ADD COLUMN FOTO_URL varchar(300)`)//2131

            // sql.push( `ALTER TABLE empresa ADD COLUMN OBS_PRINT_AGENDA varchar(9999)`)//2131

            // sql.push( `ALTER TABLE veiculos ADD COLUMN ATIVO varchar(10)`)//2130

            // sql.push( `ALTER TABLE instrutores ADD COLUMN ATIVO varchar(10)`)//2130
            // sql.push( `ALTER TABLE instrutores ADD COLUMN CELULAR(20)`)//2130
            // sql.push( `ALTER TABLE instrutores ADD COLUMN FOTO_URL(300)`)//2130
            
            // sql.push( `ALTER TABLE tabela_fixas ADD COLUMN CODIGO_ALUNO int(9)`)//2125
            // sql.push( `ALTER TABLE tabela_fixas ADD COLUMN CODIGO_SERVICO int(9)`)//2125

            // sql.push( `ALTER TABLE conta ADD COLUMN WHATS_LEMBRETE varchar(10)`)//2119
            // sql.push( `ALTER TABLE conta ADD COLUMN WHATS_ATRASADO varchar(10)`)//2119
            // sql.push( `ALTER TABLE conta ADD COLUMN CODIGO_USUARIO int(11)`)//2119



            // sql.push( `ALTER TABLE empresa ADD COLUMN C_DIAS_BLOQUEIA int(11)`)//2110

            // sql.push( `ALTER TABLE clientes ADD COLUMN SERIALIZED varchar(100)`)//2109

            // sql.push( `ALTER TABLE whats_interacao ADD COLUMN VISTO varchar(1)`)//2108

            // sql.push( `ALTER TABLE alunos ADD QUEM_CADASTROU varchar(200)`)//2106

            // sql.push( `ALTER TABLE clientes ADD API_WHATS_CONECTADO varchar(20)`)//2102

            // sql.push( `ALTER TABLE whats_respostas ADD HORA_DAS varchar(20)`)//2101
            // sql.push( `ALTER TABLE whats_respostas ADD HORA_ATE varchar(20)`)//2101
            // sql.push( `ALTER TABLE whats_respostas ADD TEXTO_AUSENTE varchar(500)`)//2101

            // sql.push( `ALTER TABLE whats_respostas ADD COLUMN INTERVALO int(9)`)//2100
            // sql.push( `ALTER TABLE whats_respostas ADD COLUMN INTERVALO_TIPO varchar(20)`)//2100
            // sql.push( `ALTER TABLE whats_interacao ADD COLUMN URL_FILE varchar(9999)`)//2100

            // sql.push( `ALTER TABLE assinaturas ADD COLUMN ID_USER int(9)`)//2099
            // sql.push( `update assinaturas set ID_USER = 0 where ID_USER is null`)

            // sql.push( `ALTER TABLE servicos ADD COLUMN DATA_EXPIRA date`)//2095
            // sql.push( `ALTER TABLE servicos ADD COLUMN ALERTA_EXPIRA varchar(1)`)//2095

            // sql.push( `ALTER TABLE registro_log ADD COLUMN CODIGO_ALUNO integer`)//2095
            // sql.push( `ALTER TABLE alunos ADD COLUMN WHATS_NIVER varchar(20)`)//2095
            
            // sql.push( `ALTER TABLE registro_log CHANGE COLUMN DESCRICAO DESCRICAO VARCHAR(500)`)//2094

            // sql.push( `ALTER TABLE alunos CHANGE COLUMN OBSERVACAO OBSERVACAO VARCHAR(9999)`)//2092
            // sql.push( `ALTER TABLE conta CHANGE COLUMN OBSERVACAO OBSERVACAO VARCHAR(9999)`)//2092

            // sql.push( `ALTER TABLE tabela_api_whats ADD COLUMN URL_FILE varchar(9999)`)//2091
            // sql.push( `ALTER TABLE alerta ADD COLUMN ENVIAR_ZAP varchar(20)`)//2091


            // sql.push( `ALTER TABLE assinaturas ADD COLUMN ANO_REAJUSTOU varchar(20)`)//2089
            // sql.push( `ALTER TABLE assinaturas ADD COLUMN double_VALOR_ANTIGO double(10,2)`)//2089

            // sql.push( `ALTER TABLE clientes ADD COLUMN DATA_TESTE_ACABA date`)//2086

            // sql.push( `ALTER TABLE alunos ADD COLUMN FOTO_URL varchar(300)`)//2086
            // sql.push( `ALTER TABLE clientes ADD COLUMN FOTO_URL varchar(300)`)//2086

            // sql.push( `ALTER TABLE assinaturas ADD COLUMN DATA_REAJUSTAR date`)//2086

            // sql.push( `ALTER TABLE usuarios ADD COLUMN CELULAR VARCHAR(20)`)//2085

            // sql.push( `ALTER TABLE alerta ADD COLUMN VISTO VARCHAR(1)`)//2084
            // sql.push( `ALTER TABLE alerta ADD COLUMN TIPO VARCHAR(20)`)//2084

            // sql.push( `ALTER TABLE assinaturas ADD COLUMN REAJUSTE VARCHAR(20)`)//2083

            // sql.push( `ALTER TABLE tabela_webhooks ADD COLUMN URL_FOTO VARCHAR(500)`)//2080
            // sql.push( `ALTER TABLE tabela_webhooks ADD COLUMN RESPOSTA VARCHAR(500)`)//2080
            // sql.push( `ALTER TABLE tabela_api_whats ADD COLUMN RESPONDEU VARCHAR(1)`)//2080
            // sql.push( `ALTER TABLE tabela_api_whats ADD COLUMN SERIALIZED VARCHAR(100)`)//2080
            // sql.push( `ALTER TABLE assinaturas ADD COLUMN SALVAR_WEBHOOK VARCHAR(1)`)//2080


            // sql.push( `ALTER TABLE tabela_api_whats CHANGE COLUMN WHATS_MSG WHATS_MSG VARCHAR(9999)`)//2078
            // sql.push( `update clientes set token = codigo*777888999 where token is null`)


        }




        // no final seta a versao atual
        sql.push( `UPDATE empresa set VERSAO_ATUAL = ${v}`)

        // console.log(sql);
        // alert(sql.length)

        console.log('1.5');
        // console.log('1.5:',sql);
        if (sql?.length>0){
          for(let i = 0; i <= sql.length; i++){

            rr = await crud_sql(this, sql[i], 'N'); 
            // console.log('r:', rr);
          }
        }
        console.log('1.6');
        console.log('updateVersoesFINAL');


    };



    function somenteNumeros(string){
        var numsStr = string.replace(/[^0-9]/g,'');
        return parseInt(numsStr);
    };



    async function manutencao_servidor(){
        
        // apaga dados apos 1 dia
        let sql = []
        let r = ''



        sql.push( `DELETE FROM registro_log WHERE data <= CURDATE() - INTERVAL 12 MONTH`)//2.1.67

        sql.push( `DELETE FROM tabela_webhooks WHERE data <= CURDATE() - INTERVAL 1 DAY`)
        sql.push( `DELETE FROM tabela_api_whats WHERE STR_TO_DATE(CONCAT(DATA, ' ', HORA), '%Y-%m-%d %H:%i:%s') <= NOW() - INTERVAL 1 DAY`)
        sql.push( `DELETE FROM whats_interacao  WHERE STR_TO_DATE(CONCAT(VALIDO_DATA, ' ', VALIDO_HORA), '%Y-%m-%d %H:%i:%s') <= NOW()`)
        sql.push( `DELETE FROM whats_interacao WHERE TIME(VALIDO_HORA) > '23:59:59'`)
        sql.push( `DELETE FROM tabela_webhooks WHERE CONTEUDO LIKE  '%isGroup":true%'`)
        sql.push( `UPDATE clientes set TOKEN = codigo*777888999 where TOKEN is null or TOKEN  =''`)
        sql.push( `update assinaturas set assinaturas.REAJUSTE = '15' where REAJUSTE is null`)
        sql.push( `DELETE FROM pix_webhooks
                    WHERE 
                    (DATA < DATE_SUB(NOW(), INTERVAL 2 DAY) AND VISTO = 'S')
                    OR
                    (DATA < DATE_SUB(NOW(), INTERVAL 4 DAY) AND VISTO = 'N')`)
        sql.push( `UPDATE assinaturas SET DATA_REAJUSTAR = CONCAT(YEAR(CURDATE()) + 1, '-01-01') WHERE DATA_REAJUSTAR IS NULL`)
        // sql.push( ``)
 

                  

        // console.log('hoje_mais:', hoje_mais(-720));

        // localStorage['SQL.manutencao_servidor:', sql]
        
        // console.log('manutencao_servidor.sql:', sql);
        // await crud_sql_canal(sql) 

        if (sql?.length>0){
            for(let i = 0; i <= sql.length; i++){
  
              r = await crud_sql_canal(sql[i]); 
            //   console.log('r:',r);
            }
        }

    };

    function hoje_mais(dias){

        let a = new Date().toLocaleDateString('pt-Br',{ datestyle: 'short', hour12: false, timeZone: 'America/Sao_Paulo' }); 
        let hoje = a

        let b = hoje.slice(6, 10) +'-'+ hoje.slice(3, 5) +'-'+ hoje.slice(0, 2) ; //formato us yyyy-mm-dd
        let today = b;

        let c = new Date(today+' 00:00:00')//sempre que criar data definir horario
        c.setDate(c.getDate() + dias)//adiciono dias na data
        let r = new Date(c).toLocaleDateString('pt-Br',{ datestyle: 'short', hour12: false, timeZone: 'America/Sao_Paulo' });//formato dd/mm/yyyy 
        let ontem = r.slice(6, 10) +'-'+ r.slice(3, 5) +'-'+ r.slice(0, 2) ; //formato us yyyy-mm-dd

        return ontem
    };


    // PRINCIPAL... É CHAMADO QUANDO SELECIONA O USUARIO E VAI ENTRAR (TELA LOGIN)
    export async function ver_permissoes_user(that, dados_usuario){
        
        
        that.overlay  = true
        

        // if (dados_usuario.BLOQUEAR == 'S'){
        // //  esta com parcela atrasada.. redireciona para o link de pagamento
        //     that?.alerta('Acesso Pendente no momento!','orange')
            
        //     that.overlay  = false 
        //     that.password_dsi = ''//limpa o campo senha
            
        //     return false
        // }
        // else{

        // }

        let isMobile = window.innerWidth < 600


        //EXPIRA EM 3 HORAS //ver se expirou o login
        var expirar  = new Date();
        expirar.setHours(expirar.getHours() + 3);
        // expirar.setMinutes(expirar.getMinutes() + 1);//testar com minutos
    
        //salvo no sessionStorage objeto em formato string
        sessionStorage['obj_user']  =  JSON.stringify(dados_usuario)
    

        //PERMISSOES:
        sessionStorage['buffer']          = 'S'//logado
        sessionStorage['refresh_size']    =  return_key()//logado
        sessionStorage['expira']          =  expirar 
        // sessionStorage['refresh_size']    = that.return_key()//logado
        //pego o mes e o dia multiplico e chego num valor.. sera analisado   

        // sessionStorage['84hfjdyruxy1_is'] =  DSirotinas.cripto(res.data[0].USUARIO)

        let superUser                      =  dados_usuario.SUPER
        sessionStorage['lg:S']             =  dados_usuario.SUPER 
        sessionStorage['lg:USUARIO']       =  dados_usuario.USUARIO
        sessionStorage['superA']           = (dados_usuario.USUARIO == 'A')
        sessionStorage['lg:F12']            = 'N'//se pode abrir F12 console
        sessionStorage['lg:CODIGO']        =  dados_usuario.CODIGO //codigo do operador

        sessionStorage['lg:EMPRESA']       =  dados_usuario.EMPRESA_NOME
        sessionStorage['lg:IDE']           =  dados_usuario.EMPRESA_CODIGO
        sessionStorage['lg:SIZE']          =  dados_usuario.EMPRESA_CODIGO * 777
        // sessionStorage['lg:BBB']           =  'cfc_'+dados_usuario.EMPRESA_CODIGO
        
        sessionStorage['lg:CADASTRO_U']    =  dados_usuario.CADASTRO_U
        sessionStorage['lg:FINANCEIRO_R']  =  dados_usuario.FINANCEIRO_R
        sessionStorage['lg:FINANCEIRO_U']  =  dados_usuario.FINANCEIRO_U
        sessionStorage['lg:TABELAS_R']     =  dados_usuario.TABELAS_R
        sessionStorage['lg:TABELAS_U']     =  dados_usuario.TABELAS_U



        
        if (dados_usuario.EMPRESA_CODIGO == '45') {
            sessionStorage['souDSi'] = 'S'
        }else{
            sessionStorage['souDSi'] = 'N'
        }


        //------------- EXECUTA ALGUMAS FUNCOES -----------------

        
        //define logado ou nao no DSI 45
        await dsi_user_online(dados_usuario.CODIGO, 'S')


        // +sessionStorage['versao']
        // REGISTRO NO LOG LOCAL
        await registra_log('LOGIN', (isMobile)? 'Entrou via Celular' : 'Entrou ')


        // ATUALIZA AS TABELAS DO BANDO DE DADOS.. NOVA COLUNAS, NOVAS TABELAS...ETC
        await atualiza_tabelas()


        // VERIFICA A VERSAO E ATUALIZA TABELAS POR VERSOES
        await updateVersoes()


        await limpar_pasta()
        
        // return true


        // ABRO OS DADOS DA EMPRESA E SALVO NA SESSION
        let r = null
        if ( r = await crud_empresa()){
            // console.log('empresa local:', r);
            // caso seja cliente novo..busca os dados da empresa la no dsi45
            r = r[0]
            if (r.CNPJ == null){
                console.log('buscar dados do dsi do ide:', dados_usuario.EMPRESA_CODIGO);

                let sql = `select * from clientes where codigo = ${dados_usuario.EMPRESA_CODIGO} `
                let empresa_45 = null
                if (empresa_45 = await crud_abrir_tabela_canal(sql)){
                    console.log('buscou:', empresa_45);

                    empresa_45 = empresa_45[0]

                    sql = `update empresa set
                           NOME         = '${empresa_45.NOME}', 
                           RAZAO_SOCIAL = '${empresa_45.NOME}', 
                           CNPJ         = '${empresa_45.CNPJ_CPF}', 
                           FONE1        = '${empresa_45.FONE}', 
                           CELULAR      = '${empresa_45.CELULAR}', 
                           EMAIL        = '${empresa_45.EMAIL}', 
                           CEP          = '${empresa_45.CEP}', 
                           ENDERECO     = '${empresa_45.ENDERECO}', 
                           BAIRRO       = '${empresa_45.BAIRRO}', 
                           CIDADE       = '${empresa_45.CIDADE}', 
                           UF           = '${empresa_45.UF}' 
                    `

                    if(await crud_sql(this, sql,'N')){
                        // apos atualizado..busca os dados locais novamente para salvar nas sessions
                        await crud_empresa()
                        
                    }

                }
            }
        }



        // executa algumas funcoes somente se for DSI 45
        // if (dados_usuario.EMPRESA_CODIGO == '45') {
            await manutencao_servidor()
        // }


        // await backup_database() //estou fazendo o backup quando da o oncreate da janela Cadastro.vue
        // await abre_pagina(this)

        // async function abre_pagina(that){
        //   that.$router.push('/cadastro')//redireciono para a pagina do router
        // }

        that.overlay = false

        return true


    };


    export async function faz_backup(){
       // EXECUTA O BACKUP DO BANCO DE DADOS


       if (url == '/api/'){
            console.log('NO BACKUP LOCAL');
            return false
       }

       let ide         = sessionStorage['lg:IDE'] 
       let agora       = new Date();

       let next_backup = ''

       if (localStorage['next_backup_'+ide]){
          next_backup   =  new Date(localStorage['next_backup_'+ide])
       }
       else{
        next_backup = agora  
       }


       if (next_backup <= agora){

         console.log('INICIANDO BACKUP...');
         
         await backup_database()

         agora.setHours(agora.getHours() + 5);//proximo backup somente daqui 5 horas

         localStorage['next_backup_'+ide] = agora

         console.log('TERMINANDO O BACKUP...');

       }
       
    };


    export async function cliente_novo(){
        let sql = `select COUNT(CODIGO) AS QT from registro_log`
    };


    async function limpar_pasta(){
        
        let parImpar =  diaParOuImpar(null, true)
        let pasta = 'temp_'+parImpar  //cria duas pasta assim eu apago a que nao for do dia

        console.log('pasta:', pasta);
        
        apagar_pasta(pasta)
    };



